'use client'

import { useEffect, useMemo, useState } from 'react'
import Script from 'next/script'
import { userIsLoggedInSelector, useYotpoLoyaltyConfigQuery } from '@segway/core'
import { useAppSelector } from '@segway/core/src/store/hooks'

// https://support.yotpo.com/v1/docs/checkout-on-site-module#dropdown-menu-module-fixed-amountpercentage-coupons

const YotpoCart = () => {
  const isLoggedIn = useAppSelector(userIsLoggedInSelector)

  const { data: loyaltyConfigData } = useYotpoLoyaltyConfigQuery(
    {},
    {
      skip: !isLoggedIn,
    },
  )

  const [loaded, setLoaded] = useState(false)

  const configData = useMemo(() => {
    if (loyaltyConfigData) {
      const yotpoSnippet = loyaltyConfigData.yotpoSnippet
      return {
        ...yotpoSnippet,
        enabled: yotpoSnippet?.is_enabled && yotpoSnippet?.guid && yotpoSnippet?.instance_id,
      }
    }
  }, [loyaltyConfigData])

  useEffect(() => {
    if (configData?.enabled && configData?.instance_id) {
      setTimeout(() => {
        // 手动初始化
        if (window?.yotpoWidgetsContainer && window?.yotpoWidgetsContainer?.initWidgets) {
          window?.yotpoWidgetsContainer?.initWidgets()
        }
      }, 500)
    }
  }, [configData, loaded])

  return configData && configData.enabled ? (
    <>
      <div
        id="swell-customer-identification"
        style={{
          display: 'none !important',
        }}
        data-authenticated="true"
        data-email={configData.email}
        data-id={configData.id}
        data-token={configData.token}
        data-tags={`[${configData.snippet}]`}></div>
      <div className="yotpo">
        <div
          className="yotpo-widget-instance"
          data-yotpo-instance-id={configData.instance_id}
          point-balance-error-text="Hubo un problema al recuperar el saldo de tus millas."></div>
      </div>
      <Script
        id="yotpo-cart"
        strategy="lazyOnload"
        src={`https://cdn-widgetsrepository.yotpo.com/v1/loader/${configData.guid}`}
        onLoad={() => {
          setLoaded(true)
        }}></Script>
    </>
  ) : null
}

export default YotpoCart
